<div class="input-group">
  @if (prepend) {
  <div class="">
    <span class="input-group-text">{{ prepend }}</span>
  </div>
  }
  <ng-content class="d-flex flex-wrap d-flex flex-nowrap"></ng-content>
  @if (append) {
  <div class="">
    <span class="input-group-text">{{ append }}</span>
  </div>
  }
</div>
